import { useMemo } from "react";
import {
  MODEL_MAIN_TAGS,
  MODEL_SECONDARY_TAGS,
  ModelTag,
} from "domains/models/constants/tags";
import { formatTagsArray, tagIdToLabel } from "domains/tags/utils";
import MenuListCategoryMultipleChoice from "domains/ui/components/Menu/MenuListCategoryMultipleChoice";
import _ from "lodash";

export interface ModelSelectTagsProps {
  selectedTags: ModelTag[];
  setSelectedTags: (values: ModelTag[]) => void;
}

export default function ModelSelectTags({
  selectedTags,
  setSelectedTags,
}: ModelSelectTagsProps) {
  const formattedTags = useMemo(
    () =>
      formatTagsArray(_.uniq([...MODEL_MAIN_TAGS, ...MODEL_SECONDARY_TAGS])),
    []
  );
  const options = useMemo(() => {
    return Object.entries(formattedTags).map(([category, tags]) => ({
      category,
      items: tags,
    }));
  }, [formattedTags]);

  const menuButtonText = useMemo(() => {
    if (!selectedTags.length) {
      return "Tags";
    }

    const label = tagIdToLabel(selectedTags[0]);
    if (selectedTags.length === 1) {
      return label;
    }
    return `${label} and ${selectedTags.length - 1} more`;
  }, [selectedTags]);

  return (
    <MenuListCategoryMultipleChoice
      options={options}
      menuButtonText={menuButtonText}
      selectedValues={selectedTags}
      setSelectedValues={(newTags) => setSelectedTags(newTags)}
      selectedCategories={selectedTags}
      setSelectedCategories={(newTags) => setSelectedTags(newTags)}
      renderLabel={tagIdToLabel}
    />
  );
}
